import { utilBuildings } from "../../../utils/utilBuildings";
import { selectBuildingsWhichProducesResourceIdAvailable } from "../selectors/selectBuildingsWhichProducesResourceIdAvailable";
export var checkAnyBuildingWhichProducesResourceIdNotProducingAvailable = function (path) { return function (action, state$, dependencies) {
    var state = state$.value;
    var availableBuildings = selectBuildingsWhichProducesResourceIdAvailable(state, action.taskType.resourceId);
    var anyBuildingNotProducing = availableBuildings.some(utilBuildings.isNotProducing);
    return anyBuildingNotProducing ? path : undefined;
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/show-me/checks/checkAnyBuildingWhichProducesResourceIdNotProducingAvailable.ts
// module id = 895
// module chunks = 3